<template>
  <div>
    <div class="mb-3 ml-3">
      <b-link :to=" tableActive === 'voucher_list' ? '/discounts/add-voucher' : '/discounts/add-automatic-disc'" class="btn btn-primary"><span class="fe fe-plus-circle"></span> Add New Voucher</b-link>
    </div>
    <div class="card">
      <div class="card-header">
        <div style="width: 100%" v-if="isSearch">
          <a-tabs>
            <a-tab-pane tab="Search Result" />
            <div slot="tabBarExtraContent" :style="{ cursor: 'pointer' }" @click="handleCloseTabSearch">
              <a-icon type="close" />
            </div>
          </a-tabs>
        </div>
        <a-form :form="form" @submit="handleSearch">
          <div class="row">
            <div class="col mt-2">
              <a-input-search
                placeholder="Voucher Code"
                :value= valueSearch
                @change="onChangeKeywordSearch"
              />
            </div>
            <div class="col-md-auto mt-1">
              <div>
                <a-form-item>
                  <a-range-picker v-decorator="['validity', rangeConfig]" />
                </a-form-item>
              </div>
            </div>
            <div class="col col-lg-1 mt-1">
              <a-form-item>
                <a-button type="primary" html-type="submit">
                  Search
                </a-button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
      <div class="card-body">
        <a-table
          :columns="columns"
          :data-source="voucherList"
          :pagination="pagination"
          :row-key="data => data.uuid"
          :loading="isLoadingTable"
          class="table-discounts"
          @change="handleTableChange"
        >
          <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
            <p v-if="record.value_type === `percentage`">
              Disc {{ record.voucher_value }}% off entire order. With minimum transaction {{ record.min_transaction | currency }}. Maximum discount {{ record.max_discount | currency }}.
            </p>
            <p v-if="record.value_type === `amount`">
              Disc {{ record.voucher_value | currency }} off entire order. With minimum transaction {{ record.min_transaction | currency }}. Maximum discount {{ record.max_discount | currency }}.
            </p>

            <div>
              <h6> Availability: </h6>
              <div> Total: {{ record.qty }} </div>
              <div> Available: {{ record.available_booked }} </div>
              <div style="cursor: pointer; color: blue" @click="showVoucherDetail(record)"> Used: {{ record.used }} </div>
              <div> Booked: {{ record.booked }} </div>
              <!-- <div> {{ record.available }} available </div>
              <div> {{ record.booked }} booked </div> -->
            </div>

            <div class="mt-3">
              <h6> Voucher Periode </h6>
              <div> {{ changeDateFormat(record.valid_from) }} - {{ changeDateFormat(record.valid_until) }} </div>
            </div>

            <div v-if="record.voucher_type_id === 2" class="mt-3">
              <h6> List Product to Discount:  </h6>
              <ul class="list-unstyled mb-0">
                <li v-for="(product, index) in JSON.parse(record.reference_list)" :key="index">
                  {{ listProductDiscount(product) }}
                </li>
              </ul>
            </div>
            <div v-if="record.voucher_type_id === 3" class="mt-3">
              <h6> Courier to Discount:  </h6>
              <ul class="list-unstyled mb-0">
                <li v-for="(courier, index) in JSON.parse(record.courier_list)" :key="index">
                  {{ listCourierDiscount(courier) }}
                </li>
              </ul>
            </div>
            <div v-if="record.voucher_type_id === 4" class="mt-3">
              <h6> Brand to Discount:  </h6>
              <ul class="list-unstyled mb-0">
                <li v-for="(brand, index) in JSON.parse(record.reference_list)" :key="index">
                  {{ listBrandDiscount(brand) }}
                </li>
              </ul>
            </div>
          </div>
          <span slot="voucher_type" slot-scope="text, record">
            <div v-if="record.voucher_type_id === 1"> Transaction Voucher </div>
            <div v-if="record.voucher_type_id === 2">
              <div class="text-bold">Product Item Voucher</div>
              <div class="text-muted"> ({{ JSON.parse(record.reference_list).length }} product) </div>
            </div>
            <div v-if="record.voucher_type_id === 3"> Shipping Voucher </div>
            <div v-if="record.voucher_type_id === 4"> Brand Voucher </div>
          </span>
          <!-- <span slot="valid_from" slot-scope="valid_from">
              <div> {{ changeDateFormat(valid_from) }} </div>
          </span>
          <span slot="valid_until" slot-scope="valid_until">
              <div> {{ changeDateFormat(valid_until) }} </div>
          </span> -->
          <template slot="action_button" slot-scope="text, record">
            <a-icon :id="`delete-${record.id}`" type="delete" class="mr-3 ml-3" @click.prevent="showConfirm(record.uuid)" style="cursor: pointer;" />
            <router-link :to="{ name: 'edit.voucher', params: { id: record.uuid } }" v-if="checkStatusVoucher(record.valid_from, record.valid_until) !== 'expired'">
              <a-icon :id="`edit-${record.id}`" type="edit" class="mr-3 ml-3"  />
            </router-link>
            <b-tooltip :target="`edit-${record.id}`" triggers="hover">
              Edit Voucher
            </b-tooltip>
            <b-tooltip :target="`delete-${record.id}`" triggers="hover">
              Delete Vouhcer
            </b-tooltip>
          </template>
          <span slot="status" slot-scope="text, record">
            <a-tag v-if="checkStatusVoucher(record.valid_from, record.valid_until) === 'expired'"
              color='red'
            >
              {{ checkStatusVoucher(record.valid_from, record.valid_until) }}
            </a-tag>

            <a-tag v-if="checkStatusVoucher(record.valid_from, record.valid_until) === 'coming soon'"
              color='blue'
            >
              {{ checkStatusVoucher(record.valid_from, record.valid_until) }}
            </a-tag>

            <a-tag v-if="checkStatusVoucher(record.valid_from, record.valid_until) === 'running'"
              color='green'
            >
              {{ checkStatusVoucher(record.valid_from, record.valid_until) }}
            </a-tag>
          </span>
        </a-table>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { Modal } from 'ant-design-vue'
import moment from 'moment'
import { i18n } from '@/localization'

export default {
  data() {
    return {
      isDiscountCode: false,
      isAutomaticDiscount: false,
      fullPage: true,
      page: 1,
      limit: 20,
      position: {
        x: 0,
        y: 0,
      },
      isSearch: false,
      valueSearch: '',
      form: this.$form.createForm(this),
      rangeConfig: {
        rules: [{
          type: 'array',
          message: 'Please select range date time',
        }],
      },
    }
  },
  methods: {
    ...mapMutations('discounts', [
      'SET_TABLE_ACTIVE',
      'SET_RANGE_DATE',
      'SET_KEYWORD_SEARCH',
    ]),

    ...mapActions('discounts', [
      'getVoucherList',
      'searchDiscountCode',
      'deleteVoucher',
      'searchAutomaticDiscount',
      'searchVoucher',
    ]),

    handleCloseTabSearch () {
      this.isSearch = false
      this.valueSearch = ''
      // this.SET_RANGE_DATE({})
      this.form.resetFields('validity')
      this.$store.dispatch('discounts/GETVOUCHERLIST', {
        page: this.page,
        limit: this.limit,
      })
    },

    changeDateFormat (value) {
      return moment.unix(value).format('YYYY-MM-DD HH:mm:ss')
    },

    handleDeleteVoucher (param) {
      this.deleteVoucher(param)
    },

    handleTableChange (pagination, filters, sorter) {
      this.page = pagination.current
      this.$store.dispatch('discounts/GETVOUCHERLIST', {
        page: pagination.current,
        limit: this.limit,
      })
    },

    listProductDiscount (value) {
      const allProduct = this.productList
      for (const i in allProduct) {
        if (allProduct[i].uuid === value) {
          return allProduct[i].product_title
        }
      }
    },

    listBrandDiscount (value) {
      const allbrand = this.brands
      for (const i in allbrand) {
        if (allbrand[i].uuid === value) {
          return allbrand[i].brand_title
        }
      }
    },

    listCourierDiscount (value) {
      const courier = this.courierList
      for (const i in courier) {
        if (courier[i].value === value) {
          return courier[i].label
        }
      }
    },

    showConfirm(value) {
      Modal.confirm({
        title: 'Do you want to delete these voucher?',
        onOk: () => {
          this.$store.dispatch('discounts/deleteVoucher', value)
            .then(_ => {
              const { current } = this.pagination
              this.$notification.success({
                message: i18n.t('notification.successDeleteVoucher'),
              })
              return this.$store.dispatch('discounts/GETVOUCHERLIST', {
                page: current,
                limit: 20,
              })
            })
        },
        onCancel() {},
        class: 'test',
      })
    },

    checkStatusVoucher (from, until) {
      /** Check expired */
      if (moment(this.changeDateFormat(until)).isBefore(moment())) {
        return 'expired'
      }
      /** Check Coming Soon */
      if (moment(this.changeDateFormat(from)).isAfter(moment())) {
        return 'coming soon'
      }
      /** Check Running Voucher */
      if (moment().isBetween(this.changeDateFormat(from), this.changeDateFormat(until))) {
        return 'running'
      }
    },

    showVoucherDetail (record) {
      // return (e) => {
      this.position.x = window.scrollX
      this.position.y = window.scrollY

      this.$router.push({
        name: 'discounts.view',
        params: {
          id: record.uuid,
        },
      })
      // }
    },

    onChangeKeywordSearch (e) {
      this.valueSearch = e.target.value
    },

    handleSearch(e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (err) return
        if (!values.validity && this.valueSearch.length === 0) {
          this.$notification.error({
            message: i18n.t('notification.failedSearchVoucher'),
          })
        } else {
          const from = values.validity && `${moment(values.validity[0]).format('YYYY-MM-DD 00:01:00.000')}${moment().format('Z')}`
          const to = values.validity && `${moment(values.validity[1]).format('YYYY-MM-DD 23:59:00.000')}${moment().format('Z')}`
          this.isSearch = true
          // this.SET_RANGE_DATE({
          //   from,
          //   to,
          // })
          // this.SET_KEYWORD_SEARCH(this.valueSearch)
          this.$store.dispatch('discounts/GETVOUCHERLIST', {
            voucher_code: this.valueSearch,
            page: this.page,
            limit: this.limit,
            from,
            to,
          })
        }
      })
    },
  },
  computed: {
    ...mapState('discounts', {
      isLoadingDiscount: state => state.isLoadingDiscount,
      voucherList: state => state.voucherList,
      search: state => state.search,
      columns: state => state.columns,
      isLoadingTable: state => state.isLoadingTable,
      pagination: state => state.pagination,
      rangeDate: state => state.rangeDate,
      keywordSearch: state => state.keywordSearch,
      tableActive: state => state.tableActive,
      productList: state => state.productList,
      brands: state => state.brands,
      courierList: state => state.courierList,
    }),
  },
  created () {
    this.$store.dispatch('discounts/GETVOUCHERLIST', { page: this.page, limit: this.limit })
    this.$store.dispatch('discounts/getProductList')
    this.$store.dispatch('discounts/getResellerList')
    this.$store.dispatch('discounts/getBrands')
    this.$store.dispatch('discounts/GETCOURIERLIST')
  },
}
</script>

<style lang="scss">
.table-discounts {
  tr {
    > th {
      padding: 10px !important;
      font-weight: bold !important;
    }
  }
}
</style>
